<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <j-editable-table
        :ref="refKeys[0]"
        :loading="publishPriceTable.loading"
        :columns="publishPriceTable.columns"
        :dataSource="publishPriceTable.dataSource"
        :maxHeight="600"
        :rowNumber="true"
        :rowSelection="true"
        :actionButton="false"
        v-if="showPriceTable"
      />
    </a-spin>
  </j-modal>
</template>

<script>

  import {getAction, httpAction, postAction} from '@/api/manage'
  import pick from 'lodash.pick'
  import {arrayToDictOptions, validateDuplicateValue} from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {FormTypes, getRefPromise} from '@/utils/JEditableTableUtil'
  import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'

  export default {
    name: "SalesPublishStockModal",
    mixins: [JEditableTableMixin],
    components: {
      JDictSelectTag,
    },
    data () {
      return {
        title:"更新库存",
        width:1200,
        visible: false,
        model: {},
        confirmLoading: false,
        showPriceTable: true,
        refKeys: ['publishPrice',],
        tableKeys: ['publishPrice',],
        publishPriceTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '商品规格',
              key: 'prodSpecs',
              type: FormTypes.select,
              dictCode: "",
              width: "200px",
              placeholder: '请选择${title}',
              defaultValue: '',
              options: [],
              validateRules: [{required: true, message: '${title}不能为空'}],
              disabled: true
            },
            {
              title: '单价',
              key: 'price',
              type: FormTypes.inputNumber,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{required: true, message: '${title}不能为空'}],
              disabled: true
            },
            {
              title: '销售库存',
              key: 'saleStock',
              type: FormTypes.inputNumber,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{required: true, message: '${title}不能为空'}],
              disabled: false
            },
            {
              title: '最大库存',
              key: 'maxStock',
              type: FormTypes.inputNumber,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{required: true, message: '${title}不能为空'}],
              disabled: true
            },
            {
              title: '饿了么规格id',
              key: 'elemeSpecId',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [],
              disabled: true
            },
            {
              title: '美团规格id',
              key: 'metuanSpecId',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [],
              disabled: true
            },
            {
              title: 'pid',
              key: 'pid',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [],
              disabled: true
            },
            {
              title: 'cid',
              key: 'cid',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [],
              disabled: true
            },
          ]
        },
        url: {
          updateStock: "/sales/salesPublishList/updateStock",
          querySpecValueById: "/manufacture/manufactureProductSpecs/queryById",
        }
      }
    },
    created () {
    },
    methods: {
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.handleProdInfoChange(this.model)
          if (this.model.publishProdSpecs) {
            this.publishPriceTable.dataSource = JSON.parse(this.model.publishProdSpecs)
          }
        })
      },
      handleProdInfoChange(record) {
        let that = this
        getAction(this.url.querySpecValueById, {id: record.prodSpec}).then(res => {
          if (res.success && res.result) {
            let resultArray = JSON.parse(res.result.specValue)
            if (resultArray.length > 0) {
              that.showPriceTable = false
              that.publishPriceTable.columns[0].options = arrayToDictOptions(resultArray)
              that.$nextTick(() => {
                that.showPriceTable = true
              })
            }
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 获取定价列表数据，组装为json赋值给publishPrice
        that.getAllTable().then(table => {
          table[0].getAll().then(tablevalue => {
            that.model.publishProdSpecs = JSON.stringify(tablevalue.values)
            let formData = {
              id: that.model.id,
              publishProdSpecs: that.model.publishProdSpecs
            }
            console.log("表单提交数据", formData)
            that.confirmLoading = true;
            postAction(that.url.updateStock, formData).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.error(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          })
        })
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>